export function TitleLarge({children, color, fontWeight = 600}) {
    return (
        <span style={{
            lineHeight: '1.05em',
            fontFamily: 'Open Sans',
            fontSize: '1.375em',
            color,
            fontWeight,
        }}>{children}</span>
    );
}
